import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EErgoFormService } from '../../../services/e-ergo-form.service';
import { ToastsService } from '../../../services/toasts.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'office-ergonomics',
  templateUrl: './office-ergonomics.component.html',
  styleUrls: ['./office-ergonomics.component.css'],
  providers: []
})
export class OfficeErgonomicsComponent implements OnInit, OnDestroy {
  private templateName = 'office-ergonomics';

  choices: string[] = ['Yes', 'No'];

  private BusyA;
  private BusyB;
  private BusyC;
  private BusyD;
  private BusyE;
  private BusyF;

  formId: string;
  formData: any;

  handsKeyboardFilesColl: string[] = [];
  handsKeyboardFilesFolder: string = 'HandsKeyboardFiles'
  handsMouseFilesColl: string[] = [];
  handsMouseFilesFolder: string = 'HandsMouseFiles'
  rearShotFilesColl: string[] = [];
  rearShotFilesFolder: string = 'RearShotFiles'
  emptyDeskFilesColl: string[] = [];
  emptyDeskFilesFolder: string = 'EmptyDeskFiles'
  neutralSeatedFilesColl: string[] = [];
  neutralSeatedFilesFolder: string = 'NeutralSeatedFiles'

  disableSubmit: boolean = true;

  validFormStatus: boolean = false;

  constructor(private eErgoFormService: EErgoFormService, private activatedRoute: ActivatedRoute, private toastsService: ToastsService,
    private titleService: Title) {
    this.titleService.setTitle('Safety Director | ' + this.templateName);
  }

  ngOnInit(): void {
    this.activatedRoute.paramMap
      .subscribe(params => {
        this.formId = params.get('formId')!;

        this.getFormData();
      });
  }

  getFormData() {
    this.BusyA = this
      .eErgoFormService
      .getForm(this.templateName, this.formId)
      .subscribe(result => {
        this.formData = result;

        if (!this.formData.handsKeyboardBlobs || this.formData.handsKeyboardBlobs.length <= 0 ||
          !this.formData.handsMouseBlobs || this.formData.handsMouseBlobs.length <= 0 ||
          !this.formData.rearShotBlobs || this.formData.rearShotBlobs.length <= 0 ||
          !this.formData.emptyDeskBlobs || this.formData.emptyDeskBlobs.length <= 0 ||
          !this.formData.neutralSeatedBlobs || this.formData.neutralSeatedBlobs.length <= 0) {
          this.disableSubmit = true;
        } else {
          this.disableSubmit = false;
        }

        if (this.formData.status == 'Initiated' || this.formData.status == 'NeedAdditionalInfo') {
          this.validFormStatus = true;
        } else {
          this.validFormStatus = false;
        }
      });
  }

  getFileDetails(e, type) {
    switch (type) {
      case 'handsKeyboard':
        this.handsKeyboardFilesColl = [];
        break;
      case 'handsMouse':
        this.handsMouseFilesColl = [];
        break;
      case 'rearShot':
        this.rearShotFilesColl = [];
        break;
      case 'emptyDesk':
        this.emptyDeskFilesColl = [];
        break;
      case 'neutralSeated':
        this.neutralSeatedFilesColl = [];
        break;
    }

    for (let i = 0; i < e.target.files.length; i++) {
      switch (type) {
        case 'handsKeyboard':
          this.handsKeyboardFilesColl.push(e.target.files[i]);
          break;
        case 'handsMouse':
          this.handsMouseFilesColl.push(e.target.files[i]);
          break;
        case 'rearShot':
          this.rearShotFilesColl.push(e.target.files[i]);
          break;
        case 'emptyDesk':
          this.emptyDeskFilesColl.push(e.target.files[i]);
          break;
        case 'neutralSeated':
          this.neutralSeatedFilesColl.push(e.target.files[i]);
          break;
      }
    }
  }

  uploadFiles(files, type) {
    if (files.length === 0)
      return;

    let updateFormData = this.compileFormData('');

    this.BusyF = this
      .eErgoFormService
      .updateForm(this.templateName, this.formId, updateFormData)
      .subscribe(result => {
        this.toastsService.showSuccess(`Successfully saved the details.`);

        this.getFormData();

        const formData = new FormData();

        let folderName;

        switch (type) {
          case 'handsKeyboard':
            folderName = this.handsKeyboardFilesFolder;
            break;
          case 'handsMouse':
            folderName = this.handsMouseFilesFolder;
            break;
          case 'rearShot':
            folderName = this.rearShotFilesFolder;
            break;
          case 'emptyDesk':
            folderName = this.emptyDeskFilesFolder;
            break;
          case 'neutralSeated':
            folderName = this.neutralSeatedFilesFolder;
            break;
        }

        for (let i = 0; i < files.length; i++) {
          let fileToUpload = <File>files[i];
          formData.append('files', fileToUpload, `${folderName}/${fileToUpload.name} `);
        }

        this.BusyB = this.eErgoFormService.uploadFiles(this.formId, formData).subscribe(response => {
          this.toastsService.showSuccess(`Successfully uploaded.`);
          this.handsKeyboardFilesColl = [];
          this.handsMouseFilesColl = [];
          this.rearShotFilesColl = [];
          this.emptyDeskFilesColl = [];
          this.neutralSeatedFilesColl = [];
          this.getFormData();
        });
      });
  }

  downloadFile(fileName, relativePath) {
    this.BusyD = this
      .eErgoFormService
      .downloadFile(fileName, relativePath)
      .subscribe(result => {
        const a = document.createElement('a')
        const objectUrl = URL.createObjectURL(result)
        a.href = objectUrl
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(objectUrl);

        this.toastsService.showSuccess(`Successfully downloaded '${fileName}'`);
      });
  }

  saveForm(status: string) {
    let updateFormData = this.compileFormData(status);

    this.BusyC = this
      .eErgoFormService
      .updateForm(this.templateName, this.formId, updateFormData)
      .subscribe(result => {
        this.toastsService.showSuccess(`Successfully saved the details.`);

        this.getFormData();
      });
  }

  compileFormData(status: string) {
    let updateFormData = {
      status: this.formData.status,
      managerName: this.formData.managerName,
      employeeEmail: this.formData.employeeEmail,
      employeeEmailNA: this.formData.employeeEmailNA,
      managerEmail: this.formData.managerEmail,
      lensGlasses: this.formData.lensGlasses,
      cradlePhone: this.formData.cradlePhone,
      handsKeyboardComment: this.formData.handsKeyboardComment,
      handsKeyboardFlag: false,
      handsMouseComment: this.formData.handsMouseComment,
      handsMouseFlag: false,
      rearShotComment: this.formData.rearShotComment,
      rearShotFlag: false,
      emptyDeskComment: this.formData.emptyDeskComment,
      emptyDeskFlag: false,
      neutralSeatedComment: this.formData.neutralSeatedComment,
      neutralSeatedFlag: this.formData.neutralSeatedFlag
    };

    if (status) {
      updateFormData.status = status;
    }

    return updateFormData;
  }

  deleteFile(fileName, relativePath) {
    this.BusyE = this
      .eErgoFormService
      .deleteFile(fileName, relativePath)
      .subscribe(result => {
        this.toastsService.showSuccess(`Successfully deleted '${fileName}'`);
        this.handsKeyboardFilesColl = [];
        this.handsMouseFilesColl = [];
        this.rearShotFilesColl = [];
        this.emptyDeskFilesColl = [];
        this.neutralSeatedFilesColl = [];
        this.getFormData();
      });
  }

  ngOnDestroy(): void {
    if (this.BusyA) {
      this.BusyA.unsubscribe();
    }

    if (this.BusyB) {
      this.BusyB.unsubscribe();
    }

    if (this.BusyC) {
      this.BusyC.unsubscribe();
    }

    if (this.BusyD) {
      this.BusyD.unsubscribe();
    }

    if (this.BusyE) {
      this.BusyE.unsubscribe();
    }

    if (this.BusyF) {
      this.BusyF.unsubscribe();
    }
  }
}
